import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {BaseUploaderComponent} from 'app/core-ui/abstract/uploadfile/baseUploader.component';
import {FileItem, FileUploader} from 'ng2-file-upload';
import {ModalDirective} from 'ngx-bootstrap/modal';

@Component({
  selector: 'file-uploader',
  templateUrl: 'fileUploader.component.html',
})
export class FileUploaderComponent extends BaseUploaderComponent implements OnInit {
  @ViewChild('errorModal') public errorModal: ModalDirective;
  @ViewChild('fileUpload') fileUpload: any;
  @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
  @Input() docId;
  @Input() actionsflow;
  @Input() status;

  public id;
  public nm;
  public continueWithSearch: boolean = true;
  public viewRole = this.securityService.isOtherStaff() || this.securityService.isAdmin();

  constructor(
    public securityService: SecurityService,
    public configService: ConfigService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
    public route: ActivatedRoute,
    public fb: UntypedFormBuilder,
  ) {
    super(securityService, configService, logger, visualsService, eventsEmitterService);
    this.getVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.getVisuals();
      },
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (params) => {
        this.logger.log(params);
        // Defaults to null if no query param provided.
        // (+) converts string 'id' to a number
        this.id = +params['id'] || null;
        this.nm = params['nm'] || null;
        this.uploader.onBuildItemForm = (item, form) => {
          let userId = localStorage.getItem('invId');
          form.append('docId', this.docId);
          form.append('userId', userId);
          form.append('type', '');
        };

        super.ngOnInit();
      },
    });
  }

  public initLoader() {
    this.group = 'uploadFiles';
    this.URL = this.configService.getServer() + 'FileUploadService/uploadFile';
    this.allowedMimeType = [
      'application/pdf',
      'text/plain',
      'image/jpeg',
      'image/png',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-powerpoint',
      'application/vnd.ms-excel',
      'application/msword',
    ];
    this.maxFileSize = 15 * 1024 * 1024; //15MB;
    this.uploader = new FileUploader({
      url: this.URL,
      authToken: 'Bearer ' + this.securityService.getFromStorage('access_token'),
      allowedMimeType: this.allowedMimeType,
      maxFileSize: this.maxFileSize,
      queueLimit: this.queueLimit,
    });

    this.uploader.onErrorItem = (item, response, status, headers) =>
      this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) =>
      this.onSuccessItem(item, response, status, headers);
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: any): any {
    this.uploader.queue;
    let res = JSON.parse(response);
    LogService.emitAlert({
      type: 'danger',
      body: res.message,
    });
  }
  onSuccessItem(item: FileItem, response: string, status: number, headers: any): any {
    let success = JSON.parse(response);
    LogService.emitAlert({
      type: 'success',
      body: success.message,
    });
    this.refresh.emit({});
  }
}
